<script>
import HumanizedDuration from 'frontend/common/humanized-duration.vue'

export default {
  name: 'SystemNotificationExecutionTime',
  props: {
    notification: {
      type: Object,
    },
  },
  components: {
    HumanizedDuration,
  },
}
</script>

<template lang="pug">
div(
  v-if="notification?.additionalPayload?.totalExecutionTime"
  v-tooltip="'Action execution timings'"
)
  span.text-nowrap
    span.me-1 Total:
    humanized-duration(
      :seconds="notification?.additionalPayload?.totalExecutionTime"
      one-letter
      use-seconds
    )
  span.text-nowrap(v-if="notification?.additionalPayload?.gisExecutionTime")
    span.mx-1 {{ ', GIS:' }}
    humanized-duration(
      :seconds="notification?.additionalPayload?.gisExecutionTime"
      one-letter
      use-seconds
    )
    span.text-nowrap
      span.me-1 {{ ', TMM:' }}
      humanized-duration(
        :seconds="notification?.additionalPayload?.totalExecutionTime - notification?.additionalPayload?.gisExecutionTime"
        one-letter
        use-seconds
      )
</template>
